<template>
    <div class="grid-7-noGutter">
        <div class="col-8 header" data-push-left="off-1"><h1>отчёт по итогам интервью по компетенциям</h1></div>
        <div class="col-6" data-push-left="off-1">
            <Person></Person>
        </div>
        <div class="col-5"></div>
        <div class="col-4" data-push-left="off-1">
            <LevelInfo :pools="pools"></LevelInfo>
        </div>
        <div class="col-5"></div>
        <div class="col-6" data-push-left="off-1">
            <Conclusion></Conclusion>
        </div>
        <div class="col-5"></div>
        <div class="col-1 save" data-push-left="off-6">
            <button :disabled="isDisableSave" @click="save">Отправить результат</button>
        </div>
        <div class="footer">
        </div>
    </div>

</template>

<script>
    import LevelInfo from '@/components/LevelInfo.vue'
    import Conclusion from '@/components/Conclusion.vue'
    import Person from '@/components/Person.vue'

    export default {
        name: "Report",
        computed: {
            pools() {
                return this.$store.getters.POOLS
            },
            isDisableSave() {
                console.log('this.$store.getters.ALL_LEVEL_FILL:', this.$store.getters.ALL_LEVEL_FILL);
                let disable = false;
                if (this.$store.getters.Q_ONE.recommendation === '') {
                    disable = true;
                }
                if (this.$store.getters.Q_ONE.surname === '') {
                    disable = true;
                }
                if (this.$store.getters.Q_ONE.name === '') {
                    disable = true;
                }
                if (this.$store.getters.Q_ONE.status === 1) {
                    disable = true;
                }
                if (this.$store.getters.ALL_COMPETENTIONS_FILL === false) {
                    disable = true;
                }
                return disable
            },
            isInfoFillAll() {
                return this.$store.getters.ALL_COMPETENTIONS_FILL
            }
        },
        methods: {
            save() {
                this.$store.dispatch('SAVE_STATUS', 1);
            }
        },
        components: {LevelInfo, Conclusion, Person}
    }
</script>

<style scoped>
    .header {
        border: black solid 1px;
    }

    .save {
        text-align: right;
    }

    .footer {
        margin-top: 100px;
    }

    button {
        border: 1px solid #0066cc;
        background-color: #0099cc;
        color: #ffffff;
        padding: 5px 10px;
    }

    button:hover {
        border: 1px solid #0099cc;
        background-color: #00aacc;
        color: #ffffff;
        padding: 5px 10px;
    }

    button:disabled,
    button[disabled] {
        border: 1px solid #999999;
        background-color: #cccccc;
        color: #666666;
    }
</style>